import React from "react";
// SVG
import man from '../../images/dev.svg';
import Typewriter from "./Typewriter";

// Animation
import {  Link } from "react-scroll";
import { motion } from "framer-motion";
import Education from '../Education/Education';
import Ido from '../Ido/Ido';
import Project from '../projects/Project';
import Contact from '../Contact/Contact';
// CSS
import "./home.css";
import Button from '../Button/Button';
import { useNavigate } from "react-router-dom";

const contentVariants = {
  initial: {
    translateX: "-100vw",
    opacity: 0,
  },

  animate: {
    translateX: "9vw",
    opacity: 1,
    transition: {
      duration: 2,
      when: "beforeChildren",
    },
  },
};

const Home = () => {

  const navigate=useNavigate();
const gotoglr=()=>{
  navigate('/gallery');

}
  
  return (
    <div className="app-container" >

   
    <section className="home-container" id="home" name="home">
          
      <motion.div
        className="content"
        variants={contentVariants}
        initial="initial"
        animate="animate"
      >
        <h2>Hi Devs!</h2>
        <h1>I’m Shyam</h1>
        <p>
          I am a
          {/* <span
            style={{ fontSize: "1.5rem", fontWeight: "600", marginLeft: "2%" }}
          >
            <Typed
              strings={[" Developer", "Dreamer","VITian"]}
              typeSpeed={80}
              backSpeed={80}
              loop
            />
          </span> */}
          <Typewriter phrases={[" Developer", "Dreamer", "VITian"]} />
        </p>
        <Link
          // className="home-btn"
          to={"gallery"}
          hashSpy={true}
          spy={true}
          smooth={true}
          delay={100}
          offset={-100}
          duration={500}
        >
        <Button  onClick={gotoglr} text={"See Beautiful Photos"} type="submit" />
        </Link>
      </motion.div>
      <motion.div
        className="svg"
        animate={{ translateY: [-20, 0, -20, 0] }}
        transition={{ yoyo: Infinity, duration: 6 }}
      >
        <img src={man} alt="Developer" />
      </motion.div>


    </section>
    <Education/>
    <Ido/>
    <Project />
    <Contact />
    </div>
  );
};

export default Home;
